/**
 * Open the MSSante webmail in a new tab.
 */
export const openMSSante = (): void => {
    window.open('https://mailiz.mssante.fr/');
};
